import Pickr from "@simonwep/pickr";
import tinycolor from "tinycolor2";
import { colorAccent, colorAccentLight } from '../../../Assets/Scripts/themeColors.js';


const body = document.querySelector('body')
const headTheme = document.querySelector('head meta[name="theme-color"]')

// Funktion zum Auslesen eines Cookies
function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
}

// Set Cookie
export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

function lightenHexColor(hex, percent) {
    // Die Hex-Farbe normalisieren (falls sie mit '#' beginnt)
    hex = hex.replace(/^#/, '');
    
    // Hex-Farbe in RGB umwandeln
    let r = parseInt(hex.substring(0, 2), 16);
    let g = parseInt(hex.substring(2, 4), 16);
    let b = parseInt(hex.substring(4, 6), 16);

    // Die RGB-Werte anpassen
    r = Math.min(255, Math.max(0, r + Math.round((255 - r) * percent / 100)));
    g = Math.min(255, Math.max(0, g + Math.round((255 - g) * percent / 100)));
    b = Math.min(255, Math.max(0, b + Math.round((255 - b) * percent / 100)));

    // Die neuen RGB-Werte wieder in Hex umwandeln
    r = r.toString(16).padStart(2, '0');
    g = g.toString(16).padStart(2, '0');
    b = b.toString(16).padStart(2, '0');

    // Die angepasste Hex-Farbe zurückgeben
    return `${r}${g}${b}`;
}

// Set Color and Theme
export function setColor(tinyColor) {
    const isDark = tinyColor.getBrightness() < 175;
    const hexColor = tinyColor.toHex()
    body.style.setProperty('--color--accent', "#" + hexColor);
    
    if (!isDark) {
        body.classList.add('dark')
        headTheme.setAttribute('content', '#83786f');
        
        if (hexColor.toLowerCase() == colorAccent.toLowerCase()) {
            body.style.setProperty('--color--accent-light', "#" + colorAccentLight);
        } else {
            const hexLightColor = lightenHexColor(hexColor, -30);
            body.style.setProperty('--color--accent-light', "#" + hexLightColor);
        }
    } else {
        body.classList.remove('dark')
        headTheme.setAttribute('content', '#f8f7f7');

        if (hexColor.toLowerCase() == colorAccent.toLowerCase()) {
            body.style.setProperty('--color--accent-light', "#" + colorAccentLight);
        } else {
            const hexLightColor = lightenHexColor(hexColor, 30);
            body.style.setProperty('--color--accent-light', "#" + hexLightColor);
        }
    }
}

if (document.querySelector('.overlay--container--pickr')) {
    // Initialisierung Pickr
    const pickr = Pickr.create({
        el: '.colorPicker',
        theme: 'monolith',
        container: '.overlay--container--pickr',
        autoReposition: false,
        default: '#' + colorAccent,
        showAlways: true,
        swatches: null,
        components: {
            preview: false,
            opacity: false,
            hue: true,
            interaction: {
                hex: false,
                rgba: false,
                hsla: false,
                hsva: false,
                cmyk: false,
                input: false,
                clear: false,
                save: true
            }
        },
        i18n: {
            'btn:save': 'Speichern',
            'aria:btn:save': 'Farbe sichern',
        }
    });

    const overlay = document.getElementById('overlay--colorWheel')
    const buttonActivate = document.querySelector('.pcr-button')
    const buttonSave = overlay.querySelector('.pcr-save')
    const buttonReset = overlay.querySelector('.button--reset')
    const picker = overlay.querySelector('.pcr-color-palette .pcr-picker')

    function closeOverlay() {
        overlay.classList.remove('visible')
        body.classList.remove('no-scroll')

        const tinyColor = tinycolor.fromRatio(pickr.getColor())
        setCookie('colorAccent', tinyColor, 30)
    }

    buttonActivate.innerHTML = `Lieblingsfarbe auswählen <div class="icon"><span></span></div>`

    // Activate Overlay
    buttonActivate.addEventListener('click', () => {
        overlay.classList.add('visible')
        body.classList.add('no-scroll')

        const colorAccent = getCookie('colorAccent')
        if (colorAccent) {
            const tinyColor = tinycolor(colorAccent)
            pickr.setColor(tinyColor.toHex())
        }

        // Oberserve Changes
        const observer = new MutationObserver(mutationsList => {
            for(const mutation of mutationsList) {
                if (mutation.attributeName === 'style') {
                    const tinyColor = tinycolor.fromRatio(pickr.getColor())
                    setColor(tinyColor)
                }
            }
        });
        observer.observe(picker, { attributes: true })

        document.addEventListener('click', (e) => {
            const target = e.target
            const overlayContainer = overlay.querySelector('.overlay--container')
            const colorWheelButton = document.querySelector(".pickr")

            if (!overlayContainer.contains(target) && !colorWheelButton.contains(target)) {
                closeOverlay()
            }
        })
    })

    // Deactivate Overlay
    buttonSave.addEventListener('click', () => {
        closeOverlay()
    })

    // Rest Color
    buttonReset.addEventListener('click', () => {
        pickr.setColor('#' + colorAccent)
        closeOverlay()
        body.style.setProperty('--color--accent-light', "#" + colorAccentLight);
    })
}